import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from 'src/app/Common/Services/login.service';
import { GlobalService } from 'src/app/global.service';


export interface timinglist {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-session-timing',
  templateUrl: './session-timing.component.html',
  styleUrls: ['./session-timing.component.css']
})

export class SessionTimingComponent implements OnInit {

  timinglists:timinglist[]= [
    {value:'30', viewValue:'30'},
    {value:'45', viewValue:'45'},
    {value:'60', viewValue:'60'},
    {value:'90', viewValue:'90'},
  ];

  sessionForm :FormGroup;
  agentLists: any[] = [];

  constructor(private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService,public _global: GlobalService) { 

  this.sessionForm =this._formbuilder.group({
    //agentNameList: ['',[Validators.required]],
    timinglist: ['',[Validators.required]]
  });
}
  
  ngOnInit() {
    
    var code ="01";
    this.loginservice.sessiondetail(code).subscribe((res:any)=>{
      
      console.log(res);
    this.sessionForm.patchValue({
      timinglist:res.responseBody.sessionDetail[0].code,
    });
  })
  }


  
  submit(){
    
      var timing=this.sessionForm.get("timinglist").value;
      var code ="01";
      this.loginservice.sessiontiming(timing,code).subscribe((res:any)=>{
      
     console.log(res);
     if(res.responseBody.validationMsg){
      this.toastr.success(res.responseBody.validationMsg, undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
     }
      })
  }

}
